<script>
import FormElement from '@wielink-application/shared/vue/components/form/input-only/date.vue'

export default FormElement;
</script>